import { connect } from 'react-redux'
import Orientation from './Orientation.jsx'
import {
    portraitOrientation,
    landscapeOrientation,
} from 'redux/print/actions'
import { isLandscapeOrientation } from 'redux/print/selectors'

const mapStateToProps = state => ({
    isLandscapeOrientation: isLandscapeOrientation(state),
})

const mapDispatchToProps = (dispatch, getState) => ({
    switchToPortraitOrientation: () => dispatch(portraitOrientation()),
    switchToLandscapeOrientation: () => dispatch(landscapeOrientation()),
})

export const OrientationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Orientation)
